import Link from "next/link";
import { useState, useRef } from "react";
import { Popover } from "antd";
import { useTranslation } from "next-i18next";
import LogoutConfirmModal from "@/components/Modal/LogoutConfirmModal";
import SwitchAccount from "@/components/Layout/SwitchAccount";
import Icon from "@/components/Icon";
import { onKeyActivate } from "@/utils/index";

interface INav {
  url: string;
  title: string;
}

/**
 * User
 * @returns
 */
const HeaderUser = ({ uuid }: { uuid: string }) => {
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState<boolean>(false);
  const LogoutModalRef: any = useRef(null);

  // logout event
  const showLogoutModal = () => {
    LogoutModalRef.current.setOpen(true);
  };

  // 菜单 data
  const navList: INav[] = [
    {
      url: "/user/points",
      title: `${t("profile_mypoint.my_points")}`,
    },
    {
      url: "/user/order",
      title: t("profile_mypurchase.title"),
    },
    {
      url: "/user/favorites",
      title: t("favorites.my_favorites"),
    },
    {
      url: "/user/address",
      title: t("profile_myaddress.address_manage"),
    },
    {
      url: "/user/voucher",
      title: t("profile_voucher.voucher"),
    },
  ];

  const onOpenChange = (open: boolean) => {
    setIsHover(open);
  };

  return (
    <>
      <Popover
        content={
          <div className="flex flex-col	bg-white text-sm">
            {navList.map((nav: INav, index: number) => (
              <Link
                key={index}
                href={nav.url}
                className="flex h-10 min-w-108px cursor-pointer items-center px-6 font-semibold text-stone-100 hover:text-primary transition-colors duration-200"
                data-qt="header_user_menu_click"
                data-qt-nav-url={nav.url}
              >
                {nav.title}
              </Link>
            ))}
            <div className="px-6 text-stone-100">
              <SwitchAccount />
            </div>
            <div
              className="flex h-10 min-w-108px cursor-pointer items-center px-6 font-semibold text-stone-100 hover:text-primary transition-colors duration-200"
              onClick={showLogoutModal}
              role="button"
              tabIndex={0}
              onKeyDown={onKeyActivate(showLogoutModal)}
              data-qt="header_logout_click"
            >
              {t("common.logout")}
            </div>
          </div>
        }
        trigger="hover"
        arrow={false}
        placement="bottom"
        overlayClassName="header-user-popover"
        onOpenChange={onOpenChange}
      >
        <Link
          href="/user/points"
          className={`ml-4 flex h-[78px] cursor-pointer items-center font-medium  ${
            isHover ? "text-primary" : "text-stone-800"
          } `}
          data-qt="header_user_entry_click"
        >
          <Icon name={isHover ? "user-red" : "user"} size={20} className="mr-1" title="icon user" />
          <div>{uuid}</div>
        </Link>
      </Popover>
      <LogoutConfirmModal onRef={LogoutModalRef} />
      <style jsx global>
        {`
          .header-user-popover .ant-popover-inner {
            border-radius: 0;
            padding: 0;
          }
        `}
      </style>
    </>
  );
};

export default HeaderUser;
